import React from "react";
import { useSelector } from "react-redux";
import languages from "languages/languages";
import styles from "./Floors.module.css";

const Floors = (props) => {
  const langState = useSelector((state) => state.language.lang);
  const youAreHere = languages[langState]["Bạn đang ở đây"];
  // console.log('langState', langState)
  const floors = [
    {
      name: "Tầng hầm",
      translate_name: "Basement",
      translate_id: 13401,
      id: 1339466,
      code: "Tầng hầm",
    },
    {
      name: "Tầng 1",
      translate_name: "First Floor",
      translate_id: 26387,
      id: 1572,
      code: "1F",
    },
    {
      name: "Tầng 2",
      translate_name: "Second Floor",
      translate_id: 2266,
      id: 269,
      code: "2F",
    },
    {
      name: "Tầng 3",
      translate_name: "Third Floor",
      translate_id: 2267,
      id: 290,
      code: "3F",
    },
    {
      name: "Tầng thượng",
      translate_name: "Rooftop",
      translate_id: 13401,
      id: 13394,
      code: "Tầng thượng và tầng hầm",
    },
  ];
  return (
    <div className={styles.FloorsContainer}>
      <div className={styles.Floors}>
        {floors.map((floor) => {
          const activeClass =
            props.activeFloor === floor.id ? styles.active : "";
          return (
            <div
              key={floor.id}
              className={"btn " + styles.Floor + " " + activeClass}
              onClick={() => props.select(floor)}
            >
              {floor.code === props.userInFloor ? (
                <span className={styles.location}>{youAreHere}</span>
              ) : null}

              {langState === "vi" ? floor.name : floor.translate_name}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Floors;
